import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX } from '@fortawesome/free-solid-svg-icons';
import QuizFeedback from "../../components/fun_stuff/QuizFeedback";

const letters = {
    0: 'a',
    1: 'b',
    2: 'c',
    3: 'd',
    4: 'e',
}

const Question = (({ question, index, checkAnswer, showCheck, showX, active, showAnswers }) => {

    return (
        <div key={`question-${index}`} className="question">
            <h4>{`${index + 1}. ${question.question}`}</h4>
            <div className="answers">
                <form className="answer-form">
                    {question?.options?.map((option, i) => (
                        <div key={`${index}-${i}`} className="answer-option">
                        <label htmlFor={`question-${index}-${option}`} className="answer-label">
                            <input
                            type="radio"
                            id={`question-${index}-${option}`}
                            name={`question-${index}`}
                            value={option}
                            className="answer-radio"
                            disabled={!active}
                            readOnly={!active}
                            onClick={checkAnswer ? () => checkAnswer(index, option) : undefined}
                            {...(!active && { checked: question.answer === option })}
                            />
                            <div className="letter">
                                {`${letters[i]}.`}
                            </div>
                            <div className="answer-answer">
                                {option}
                            </div>
                        </label>
                        </div>
                    ))}
                </form>
                <div className="answer-check">
                    {showCheck &&
                    <FontAwesomeIcon icon={faCheck} className={`fa-2xl question-${index} check`}/>}
                    {showX &&
                    <FontAwesomeIcon icon={faX} className={`fa-2xl question-${index} x`}/>}
                </div>
            </div>

            <QuizFeedback question_id={question.id} index={index} />

            <h5 className={`correct-answer question-${index} ${showAnswers ? 'active': ''}`}>Correct Answer: {letters[question.options.indexOf(question.correct_answer)].toUpperCase()}</h5>
            <p className={`answer-explanation question-${index} ${showAnswers ? 'active': ''}`}>{question.explanation}</p>
        </div>
    );
})

export default Question